import React from 'react';
import { docAssistSuggestions } from '../../utils/docAssist';

export default function DocAssistPanel({ complaint, age, onApply }) {
  const s = docAssistSuggestions(complaint, age);
  if (!complaint?.trim()) {
    return (
      <div className="card doc-assist">
        <h4>Clinical Assist</h4>
        <p className="hint">Enter chief complaint to get AI-assisted suggestions.</p>
      </div>
    );
  }

  return (
    <div className="card doc-assist">
      <h4>Clinical Assist</h4>
      <p className="hint" style={{ fontSize: 11 }}>Suggested workup based on complaint — review before applying.</p>
      <div className="doc-assist-block">
        <strong>Diagnosis</strong>
        <div className="q-tag-row">{s.diagnosis.map((d) => <span key={d} className="q-tag on">{d}</span>)}</div>
      </div>
      {s.labs.length > 0 && (
        <div className="doc-assist-block">
          <strong>Investigations</strong>
          <div className="q-tag-row">{s.labs.map((l) => <span key={l} className="q-tag">{l}</span>)}</div>
        </div>
      )}
      {s.rx.length > 0 && (
        <div className="doc-assist-block">
          <strong>Medicines</strong>
          <div className="q-tag-row">{s.rx.map((r) => <span key={r} className="q-tag">{r}</span>)}</div>
        </div>
      )}
      {onApply && (
        <button type="button" className="btn btn-sm btn-primary" style={{ marginTop: 8 }} onClick={() => onApply(s)}>
          Apply to EMR
        </button>
      )}
    </div>
  );
}
